import React from 'react';
import LandingNav from '../components/LandingNav';
import Footer from '../components/Footer';
import './PrivacyPolicy.css';

const TermsOfService = () => {
  return (
    <div className="legal-page">
      <LandingNav />
      <div className="legal-content">
        <h1>Terms of Use</h1>
        <p><strong>Last Updated:</strong> January 2025</p>
        <p>
          Welcome to Trckle. By using our social media management platform ("Service"), you agree
          to the following Terms of Use and our Privacy Policy.
        </p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing Trckle, you affirm that you have read and agree to these Terms. If you do not
          agree, do not use the Service.
        </p>

        <h2>2. User Responsibilities</h2>
        <p>You agree to:</p>
        <ul>
          <li>Provide accurate registration information</li>
          <li>Use Trckle only for lawful purposes</li>
          <li>Connect only social media accounts you own or are authorized to manage</li>
          <li>Comply with all platform rules (Meta, TikTok, X, LinkedIn, etc.)</li>
        </ul>

        <h2>3. Connected Accounts & Permissions</h2>
        <p>
          When connecting a social media account, you grant Trckle permission to perform only the
          actions you authorize, including:
        </p>
        <ul>
          <li>Publishing scheduled posts</li>
          <li>Retrieving analytics</li>
          <li>Managing assets and metadata</li>
        </ul>
        <p>We never store your third-party passwords.</p>

        <h2>4. Content Ownership</h2>
        <p>
          You retain all ownership of your uploaded content, drafts, captions, and media. By using
          Trckle, you grant a temporary license for us to process and publish content solely for your
          scheduled actions.
        </p>

        <h2>5. Prohibited Use</h2>
        <p>You may not use Trckle to:</p>
        <ul>
          <li>Spam or violate platform posting rules</li>
          <li>Scrape, harvest, or misuse platform APIs</li>
          <li>Engage in harassment, hate, or illegal content</li>
          <li>Reverse-engineer or interfere with the service</li>
        </ul>

        <h2>6. Limitation of Liability</h2>
        <p>Trckle is not responsible for:</p>
        <ul>
          <li>Posting errors caused by third-party API outages</li>
          <li>Account suspensions by social networks</li>
          <li>User misconfiguration or misuse of the service</li>
        </ul>

        <h2>7. Termination</h2>
        <p>
          We may suspend or terminate accounts that violate these Terms, abuse API permissions, or
          compromise platform security. You may close your account at any time.
        </p>

        <h2>8. Service Modifications</h2>
        <p>
          We may update, modify, or discontinue features as needed to maintain compliance or
          improve the platform.
        </p>

        <h2>9. Governing Law</h2>
        <p>These Terms are governed by the laws of the State of California.</p>

        <h2>10. Contact</h2>
        <p>
          For support or legal questions, email us at:<br />
          <strong>trcklesocial@gmail.com</strong>
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default TermsOfService;
